(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[459],{

/***/ 6376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ d; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/@pinvest/sirius-divider/dist/divider/index.esm.js
var r={divider:"pin-divider___sujei",divider_line:"pin-divider_line___74y6i",divider_gap:"pin-divider_gap___ea708"};const d=({gutter:d,variant:a})=>(0,jsx_runtime.jsx)("hr",{className:classnames_default()(r.divider,r[`divider_${a??"line"}`]),style:{marginBlock:d}});d.defaultProps={variant:"line"},d.displayName="Divider";

;// CONCATENATED MODULE: ./node_modules/@pinvest/sirius-divider/dist/index.esm.js



/***/ }),

/***/ 5256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N6": function() { return /* reexport */ index_esm_s; },
  "nv": function() { return /* reexport */ index_esm_x; }
});

// UNUSED EXPORTS: OTPInput

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/@pinvest/sirius-input/dist/otp-input/index.esm.js
var i="pin-otp-input-form___1ov77",l="pin-otp-input___av09w",p="pin-otp-input_has-error___1bwf6";const f=/^[0-9]+$/;function m(t){return t&&f.test(t)?t:""}const d=(0,react.forwardRef)((({autoFocus:e=!0,defaultValue:d,disabled:h,hasError:g,onChange:b,onSubmit:v,testId:_,totalInputElements:y=4,value:x},w)=>{const A=classnames_default()(i,{[p]:g}),{isValuePropAvailable:V,sanitizedValueProp:D}=(0,react.useMemo)((()=>({isValuePropAvailable:"string"==typeof x,sanitizedValueProp:m(x)})),[x]),[M,N]=(0,react.useState)(m(d)||D),P=(0,react.useRef)(M),k=(0,react.useRef)([]);(0,react.useImperativeHandle)(w,(()=>({clearValue(){N(""),P.current="",k.current[0]?.focus()}})),[]);const j=(0,react.useCallback)((t=>e=>{k.current[t]=e}),[]),C=(0,react.useCallback)((t=>{const e=Number(t.currentTarget.dataset.index);switch(t.key){case"Delete":case"Backspace":{t.preventDefault();const r=M.split("");r.splice(e,1);const n=r.join("").substring(0,y);N(n),P.current=n,"function"==typeof b&&b(n);const a=Math.max(e-1,0);k.current[a]?.focus();break}case"ArrowLeft":{t.preventDefault();const r=Math.max(e-1,0);k.current[r]?.focus();break}case"ArrowRight":{t.preventDefault();const r=Math.min(e+1,y-1);k.current[r]?.focus()}}}),[b,y,M]),I=(0,react.useCallback)((async t=>{const e=Number(t.currentTarget.dataset.index),r=t.target.value;if(!f.test(r))return;const n=M.split(""),a=r.substring(0,y-e).split(""),o=e+a.length,s=Math.min(o,y-1);for(let t=0;t<a.length;t++)n[e+t]=a[t];const u=n.join("").substring(0,y);N(u),P.current=u,"function"==typeof b&&b(u),k.current[s]?.focus(),u.length===y&&"function"==typeof v&&await v(u)}),[b,v,y,M]);return (0,react.useEffect)((()=>{e&&k.current[0]?.focus()}),[e]),(0,react.useEffect)((()=>{V&&D!==P.current&&(N(D),P.current=D)}),[V,D]),(0,jsx_runtime.jsx)("form",{className:A,"data-testid":_,children:Array.from({length:y}).map(((e,r)=>(0,jsx_runtime.jsx)("input",{autoComplete:"one-time-code",className:l,"data-index":r,"data-testid":`txt-otp-${r+1}`,disabled:h,inputMode:"numeric",onChange:I,onKeyDown:C,ref:j(r),value:M.charAt(r)},`otp-input-${r}`)))})}));d.displayName="OTPInput";

;// CONCATENATED MODULE: ./node_modules/@pinvest/sirius-input/dist/text-field/index.esm.js
function r(){return (0,jsx_runtime.jsx)("svg",{width:"16",height:"16",viewBox:"0 0 16 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:(0,jsx_runtime.jsx)("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M2.58623 9.28773C1.80459 8.50658 1.80459 7.23956 2.58624 6.45841L6.46176 2.58534C7.24271 1.80489 8.50834 1.80489 9.28929 2.58534L13.1648 6.45841C13.9465 7.23956 13.9465 8.50658 13.1648 9.28773L9.28929 13.1608C8.50834 13.9413 7.2427 13.9412 6.46176 13.1608L2.58623 9.28773ZM7.23693 5.3211C7.23693 4.96829 7.52294 4.68229 7.87574 4.68229C8.22855 4.68229 8.51455 4.96829 8.51455 5.3211V7.87239C8.51455 8.2252 8.22855 8.5112 7.87574 8.5112C7.52294 8.5112 7.23693 8.2252 7.23693 7.87239V5.3211ZM7.87592 9.46848C7.43537 9.46848 7.07741 9.82562 7.07741 10.2662C7.07741 10.7067 7.43537 11.0639 7.87592 11.0639C8.31647 11.0639 8.67443 10.7067 8.67443 10.2662C8.67443 9.82562 8.31647 9.46848 7.87592 9.46848Z",fill:"currentColor"})})}var _="pin-text-field___4unbr",index_esm_d="pin-text-field__label___y497f",n="pin-text-field_has-error___t31oj",s="pin-text-field_disabled___13g2x",a="pin-text-field__prefix___1naw4",index_esm_p="pin-text-field__suffix___vpauv",index_esm_f="pin-text-field__input___mu9zt",o="pin-text-field_full-width___1oe9k",c="pin-text-field__description___ch2m3";const index_esm_x=(0,react.forwardRef)((({description:t,disabled:x,hasError:m,hideErrorDescriptionIcon:h,isFullWidth:u,prefix:C,suffix:v,type:w="text",...N},b)=>{const g=classnames_default()(_,{[n]:m,[o]:u,[s]:x});return (0,jsx_runtime.jsxs)("div",{className:g,children:[(0,jsx_runtime.jsxs)("label",{className:index_esm_d,children:[C&&(0,jsx_runtime.jsx)("div",{className:a,children:C}),(0,jsx_runtime.jsx)("input",{...N,className:index_esm_f,disabled:x,ref:b,type:w}),v&&(0,jsx_runtime.jsx)("div",{className:index_esm_p,children:v})]}),t&&(0,jsx_runtime.jsxs)("div",{className:c,children:[m&&!h&&(0,jsx_runtime.jsx)(r,{}),t]})]})}));index_esm_x.displayName="TextField";

;// CONCATENATED MODULE: ./node_modules/@pinvest/sirius-input/dist/currency-field/index.esm.js
const u=e=>e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&"),index_esm_l=(e,r)=>{const{decimalSeparator:t}=r;if(""===e||void 0===e)return"";if("-"===e)return"-";const n=new RegExp("((^|\\D)-\\d)|-").test(e),a="."!==t?((e,r,t)=>{let n=e;return r&&"."!==r&&(n=n.replace(RegExp(u(r),"g"),"."),t&&"-"===r&&(n=`-${n.slice(1)}`)),n})(e,t,n):e,o=((e,r)=>{const{groupSeparator:t}=r;return e.reduce(((e,{type:r,value:n})=>"group"===r?[...e,void 0!==t?t:n]:[...e,n]),[""]).join("")})(new Intl.NumberFormat(void 0,{minimumFractionDigits:0,maximumFractionDigits:20}).formatToParts(Number(a)),r);return[o,a.slice(-1)===t?t:""].join("")},currency_field_index_esm_p=(e,r)=>{const{groupSeparator:t,decimalSeparator:n}=r,a=new RegExp("((^|\\D)-\\d)|-").test(e),o=((e,r=",")=>{const t=new RegExp(u(r),"g");return e.replace(t,"")})(e,t),i=((e,r)=>{const t=u(r.join("")),n=new RegExp(`[^\\d${t}]`,"gi");return e.replace(n,"")})(o,[t,n]),l=a?"-":"";if(n&&i.includes(n)){const[e]=i.split(n);return`${l}${e}`}return`${l}${i}`},index_esm_c={groupSeparator:".",decimalSeparator:","},index_esm_s=(0,react.forwardRef)((({value:r,defaultValue:u,prefix:s="Rp",onChange:m,onDisplayValueChange:g,...d},f)=>{const x=(0,react.useMemo)((()=>null!=u?index_esm_l(String(u),index_esm_c):null!=r?index_esm_l(String(r),index_esm_c):""),[r,u]),[S,v]=(0,react.useState)(x);(0,react.useEffect)((()=>{void 0!==r&&v(index_esm_l(String(r),index_esm_c))}),[r]);const y=(0,react.useCallback)((e=>{const{decimalSeparator:r,groupSeparator:t}=index_esm_c;let n=e.target.value;const a=currency_field_index_esm_p(n,index_esm_c);if(""===a||"-"===a||a===r)return v(a),void("function"==typeof m&&(e.target.value="",m(e)));n=index_esm_l(a,index_esm_c),v(n),"function"==typeof g&&g(n),"function"==typeof m&&(e.target.value=n.replaceAll(t,""),m(e))}),[m,g]),$=(0,react.useMemo)((()=>{const{decimalSeparator:e}=index_esm_c;return null==r||"-"===S||e&&r===e?S:index_esm_l(r,index_esm_c)}),[r,S]);return (0,jsx_runtime.jsx)(index_esm_x,{type:"text",inputMode:"decimal",onChange:y,value:$,ref:f,prefix:s,...d})}));index_esm_s.displayName="CurrencyField";

;// CONCATENATED MODULE: ./node_modules/@pinvest/sirius-input/dist/index.esm.js



/***/ }),

/***/ 7705:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(6189);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ pages_LoginPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-button/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(4936);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-divider/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(6376);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-input/dist/index.esm.js + 3 modules
var sirius_input_dist_index_esm = __webpack_require__(5256);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/shared/MetaHead/index.tsx
var MetaHead = __webpack_require__(6210);
// EXTERNAL MODULE: ./src/components/shared/MultipleChipSelect/index.tsx
var MultipleChipSelect = __webpack_require__(7040);
// EXTERNAL MODULE: ./src/components/shared/NavigationBar/index.tsx + 4 modules
var NavigationBar = __webpack_require__(3627);
// EXTERNAL MODULE: ./src/components/shared/OTPForm/index.tsx
var OTPForm = __webpack_require__(3547);
// EXTERNAL MODULE: ./src/components/shared/templates/AppTemplate/index.tsx + 3 modules
var AppTemplate = __webpack_require__(8446);
// EXTERNAL MODULE: ./src/components/shared/templates/CenterContentTemplate/index.tsx
var CenterContentTemplate = __webpack_require__(1785);
// EXTERNAL MODULE: ./src/components/shared/Text/index.tsx
var Text = __webpack_require__(1823);
// EXTERNAL MODULE: ./src/constants/externalUrls.ts
var externalUrls = __webpack_require__(7928);
// EXTERNAL MODULE: ./src/constants/images.ts
var constants_images = __webpack_require__(145);
// EXTERNAL MODULE: ./src/constants/internalUrls.ts
var internalUrls = __webpack_require__(7660);
// EXTERNAL MODULE: ./src/constants/verification.ts
var verification = __webpack_require__(7134);
// EXTERNAL MODULE: ./src/contexts/featureFlag/index.ts
var featureFlag = __webpack_require__(9633);
// EXTERNAL MODULE: ./src/contexts/oauth/index.ts
var oauth = __webpack_require__(4854);
// EXTERNAL MODULE: ./src/repositories/auth/requestOtp/useRequestOtp.ts + 1 modules
var useRequestOtp = __webpack_require__(4110);
// EXTERNAL MODULE: ./src/repositories/auth/userInfo/index.ts
var auth_userInfo = __webpack_require__(3999);
// EXTERNAL MODULE: ./src/repositories/auth/verifyOtp/useVerifyOtp.ts + 1 modules
var useVerifyOtp = __webpack_require__(4797);
// EXTERNAL MODULE: ./src/repositories/utils.ts + 10 modules
var utils = __webpack_require__(7115);
// EXTERNAL MODULE: ./src/services/cookies/index.ts
var cookies = __webpack_require__(409);
// EXTERNAL MODULE: ./src/services/eventTracking/index.ts + 1 modules
var eventTracking = __webpack_require__(7756);
// EXTERNAL MODULE: ./src/services/eventTracking/events/signIn/constants.ts
var constants = __webpack_require__(6986);
;// CONCATENATED MODULE: ./src/services/eventTracking/events/signIn/index.ts


function signInOpenPage(params) {
    return {
        event: constants/* signInEvent.openPage */.c.openPage,
        eventProps: (0,_object_spread/* default */.Z)({
            page_name: "sign_in_form"
        }, params)
    };
}
function signInGetResponse(params) {
    return {
        event: constants/* signInEvent.getResponse */.c.getResponse,
        eventProps: (0,_object_spread/* default */.Z)({}, params)
    };
}

// EXTERNAL MODULE: ./src/services/eventTracking/events/signUp/constants.ts
var signUp_constants = __webpack_require__(8664);
// EXTERNAL MODULE: ./src/services/eventTracking/events/signUp/types.ts
var types = __webpack_require__(531);
;// CONCATENATED MODULE: ./src/components/pages/LoginPage/config.ts
var metaTitle = "Masuk | Pinhome Financial";

// EXTERNAL MODULE: ./src/components/pages/LoginPage/styles.module.css
var styles_module = __webpack_require__(8289);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/utils/validator/index.ts
var validator = __webpack_require__(4575);
;// CONCATENATED MODULE: ./src/components/pages/LoginPage/utils.ts

var validators = {
    phoneNumber: validator/* validatePhoneNumber */.Y0
};

;// CONCATENATED MODULE: ./src/components/pages/LoginPage/index.tsx








































var LoginPage = function() {
    var enable_modify_registration_flow = (0,featureFlag/* useFeatureFlag */.y)().enable_modify_registration_flow;
    var ref = (0,react.useState)(""), phoneNumber = ref[0], setPhoneNumber = ref[1];
    var ref1 = (0,react.useState)(undefined), phoneError = ref1[0], setPhoneError = ref1[1];
    var ref2 = (0,react.useState)(verification/* VerificationType.WHATSAPP */.R4.WHATSAPP), verificationMethod = ref2[0], setVerificationMethod = ref2[1];
    var ref3 = (0,react.useState)("login"), step = ref3[0], setStep = ref3[1];
    var ref4 = (0,react.useState)(null), secretCode = ref4[0], setSecretCode = ref4[1];
    var ref5 = (0,react.useState)(""), errorVerifyOtp = ref5[0], setErrorVerifyOtp = ref5[1];
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)(""), trackingAttribute = ref6[0], setTrackingAttribute = ref6[1];
    var login = (0,oauth/* useOAuth */.F)().login;
    var handleChangeVerificationMethod = (0,react.useCallback)(function(newValue) {
        if (typeof newValue == "string") {
            setVerificationMethod(newValue);
        }
    }, []);
    var handleChangePhoneNumber = (0,react.useCallback)(function(e) {
        var validatedValue = e.target.value.replace(/[^0-9]/g, "");
        setPhoneNumber(validatedValue);
        setPhoneError(validators.phoneNumber(validatedValue));
    }, []);
    var handleRequestOtpSuccess = (0,react.useCallback)(function() {
        setPhoneError(undefined);
        setStep("otp-verification");
    }, []);
    var handleRequestOtpError = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(err) {
            var ref, ref1, ref2, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return (0,utils/* parseError */.nU)(err);
                    case 3:
                        res = _ctx.sent;
                        if (!(((ref = res.data) === null || ref === void 0 ? void 0 : ref.message) == "phone number is not registered")) {
                            _ctx.next = 9;
                            break;
                        }
                        setPhoneError("Nomor handphone belum terdaftar");
                        return _ctx.abrupt("return");
                    case 9:
                        if (!((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.message.includes("2005505"))) {
                            _ctx.next = 14;
                            break;
                        }
                        setPhoneError("Coba beberapa saat lagi");
                        return _ctx.abrupt("return");
                    case 14:
                        if (!(((ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.message) == "customer type not allowed to login")) {
                            _ctx.next = 17;
                            break;
                        }
                        setPhoneError("Nomor handphone ini terdaftar sebagai akun personal, silakan masuk akun melalui aplikasi Rekan Agen Pinhome");
                        return _ctx.abrupt("return");
                    case 17:
                        setPhoneError("Terjadi kesalahan pada server");
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(err) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var ref7 = (0,useRequestOtp/* default */.Z)({
        onSuccess: handleRequestOtpSuccess,
        onError: handleRequestOtpError
    }), requestOtpRep = ref7.data, isRequestingOtp = ref7.isLoading, requestOtp = ref7.fetch;
    (0,react.useEffect)(function() {
        var ref;
        if ((requestOtpRep === null || requestOtpRep === void 0 ? void 0 : (ref = requestOtpRep.data) === null || ref === void 0 ? void 0 : ref.secretCode) != null) {
            setSecretCode(requestOtpRep.data.secretCode);
        }
    }, [
        requestOtpRep
    ]);
    (0,react.useEffect)(function() {
        var res = cookies/* default.get */.Z.get(constants/* signInEvent.openPage */.c.openPage);
        cookies/* default.delete */.Z["delete"](constants/* signInEvent.openPage */.c.openPage);
        var parsedRes = res ? JSON.parse(res) : null;
        if (parsedRes === null || parsedRes === void 0 ? void 0 : parsedRes.attribute) {
            setTrackingAttribute(parsedRes.attribute);
            eventTracking/* default.pushEvent */.Z.pushEvent(signInOpenPage({
                attribute: parsedRes.attribute
            }));
        }
    }, []);
    var handleOnBackButton = (0,react.useCallback)(function() {
        if (step === "otp-verification") {
            setStep("login");
            setErrorVerifyOtp("");
            return;
        }
        router.back();
    }, [
        router,
        step
    ]);
    var handleValidate = (0,react.useCallback)(function() {
        var errPhoneNumber = validators.phoneNumber(phoneNumber);
        if (errPhoneNumber) setPhoneError(errPhoneNumber);
        return !!errPhoneNumber;
    }, [
        phoneNumber
    ]);
    var handleRequestOtp = (0,react.useCallback)(function() {
        if (isRequestingOtp) return;
        var err = handleValidate();
        if (err) return;
        requestOtp({
            medium: verificationMethod,
            otpType: "login",
            countryCode: "62",
            phoneNumber: phoneNumber
        });
    }, [
        handleValidate,
        isRequestingOtp,
        phoneNumber,
        requestOtp,
        verificationMethod
    ]);
    var handleVerifyOtpError = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(err) {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,utils/* parseError */.nU)(err);
                    case 2:
                        res = _ctx.sent;
                        if (res) {
                            setErrorVerifyOtp("Pastikan kode yang Anda masukkan sudah benar");
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(err) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var handleVerifyOtpSuccess = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(resp) {
            var ref, ref1, userInfo, ref2, redirectPath;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(resp === null || resp === void 0 ? void 0 : resp.data.token)) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 4;
                        return (0,auth_userInfo/* fetchUserInfo */.CS)(resp.data.token);
                    case 4:
                        userInfo = _ctx.sent;
                        if (trackingAttribute) {
                            eventTracking/* default.pushEvent */.Z.pushEvent(signInGetResponse({
                                customer_guid: userInfo.data.guid,
                                attribute: trackingAttribute
                            }));
                        }
                        login((0,_object_spread/* default */.Z)({
                            accessToken: resp.data.token
                        }, userInfo.data));
                    case 7:
                        ;
                        redirectPath = (ref2 = (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.redirect) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref2 !== void 0 ? ref2 : "";
                        if (redirectPath) {
                            _ctx.next = 12;
                            break;
                        }
                        router.push(internalUrls/* default.dasboard */.Z.dasboard);
                        return _ctx.abrupt("return");
                    case 12:
                        router.push(redirectPath);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(resp) {
            return _ref.apply(this, arguments);
        };
    }(), [
        login,
        router,
        trackingAttribute
    ]);
    var ref8 = (0,useVerifyOtp/* useVerifyLoginOtp */.W)({
        onSuccess: handleVerifyOtpSuccess,
        onError: handleVerifyOtpError
    }), verifyOtp = ref8.fetch;
    var handleVerifyOtp = (0,react.useCallback)(function(verificationCode) {
        if (secretCode != null && verificationCode) {
            verifyOtp({
                medium: verificationMethod,
                otpType: "login",
                countryCode: "62",
                phoneNumber: phoneNumber,
                secretCode: secretCode,
                verificationCode: verificationCode
            });
        }
    }, [
        phoneNumber,
        secretCode,
        verificationMethod,
        verifyOtp
    ]);
    var disableButton = (0,react.useMemo)(function() {
        return isRequestingOtp || phoneError != undefined || phoneNumber == "";
    }, [
        isRequestingOtp,
        phoneError,
        phoneNumber
    ]);
    var handleSignUpOnClicked = (0,react.useCallback)(function() {
        cookies/* default.add */.Z.add({
            name: signUp_constants/* signUpEvent.openPage */.w.openPage,
            value: JSON.stringify({
                attribute: types/* SignUpAttr.SIGN_IN_FORM */.f.SIGN_IN_FORM
            })
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppTemplate/* default */.Z, {
        showFooter: false,
        color: "subtle",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaHead/* default */.Z, {
                title: metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["login-page__navbar"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar/* default */.Z, {
                    isShowMenu: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenterContentTemplate/* default */.Z, {
                showBackButton: step == "otp-verification",
                title: "".concat(step == "login" ? "Masuk ke Akun Pinhome Financial" : "Masukan Kode Verifikasi"),
                onBack: handleOnBackButton,
                children: [
                    step == "login" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: (styles_module_default())["login-page__form"],
                        "data-testid": "frm-login",
                        onSubmit: handleRequestOtp,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["login-page__title"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    component: "h2",
                                    typography: "heading1",
                                    children: "Masuk Akun Pinhome Financial"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                component: "h2",
                                typography: "body2",
                                margin: "0 0 16px 0",
                                children: "Masukkan nomor handphone Anda untuk masuk."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sirius_input_dist_index_esm/* TextField */.nv, {
                                prefix: "+62",
                                placeholder: "Ketik nomor handphone Anda",
                                type: "tel",
                                value: phoneNumber,
                                onChange: handleChangePhoneNumber,
                                description: phoneError,
                                hasError: !!phoneError,
                                "data-testid": "txt-phoneNumber"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                component: "p",
                                typography: "label2",
                                margin: "16px 0 10px 0",
                                children: "Terima Kode Verifikasi Melalui:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["login-page__chip"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultipleChipSelect/* default */.Z, {
                                    groupName: "verification-method",
                                    type: "radio",
                                    options: verification/* verificationTypeOptions */.Kc,
                                    values: verificationMethod,
                                    onChange: handleChangeVerificationMethod,
                                    testId: "chip-verification-method"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ButtonPrimary */.DF, {
                                testId: "btn-masuk-login",
                                fullWidth: true,
                                disabled: disableButton,
                                onClick: handleRequestOtp,
                                children: "Masuk"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                typography: "body2",
                                margin: "17px 0 0 0",
                                textAlign: "center",
                                component: "p",
                                children: [
                                    "Belum punya akun? ",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ButtonLink */.ZP, {
                                        href: internalUrls/* default.register */.Z.register,
                                        onClick: handleSignUpOnClicked,
                                        testId: "lnk-singInForm-signUp",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "primary",
                                            typography: "body2",
                                            children: "Daftar Akun"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Divider */.i, {
                                gutter: 16
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                typography: "body2",
                                textAlign: "center",
                                component: "p",
                                color: "subtle",
                                children: [
                                    "Butuh Bantuan atau Solusi ? Silakan ",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: externalUrls/* waPinfinance2 */.Y,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (styles_module_default()).link,
                                            children: "Hubungi Kami"
                                        })
                                    })
                                ]
                            }),
                            enable_modify_registration_flow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (styles_module_default())["login-form__section_center"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                typography: "body3",
                                                color: "subtle",
                                                children: "Layanan Komisi Instan dari Pinhome Financial didukung oleh PT Indo Fin Tek yang terdaftar dan diawasi oleh OJK."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (styles_module_default())["login-form__partners"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (styles_module_default())["login-form__partner-logo"],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: constants_images/* dompetKilatLogoUrl */.rC,
                                                            layout: "fill",
                                                            objectFit: "contain",
                                                            alt: "dompet-kilat-logo"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (styles_module_default())["login-form__partner-logo"],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: constants_images/* ojkLogoUrl */.PA,
                                                            layout: "fill",
                                                            objectFit: "contain",
                                                            alt: "ojk-logo"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                typography: "body3",
                                                color: "subtle",
                                                children: [
                                                    "\xa9 2022 - ",
                                                    new Date().getFullYear(),
                                                    " Pinhome Financial"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    step == "otp-verification" && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: (styles_module_default())["login-page__otp"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OTPForm/* default */.Z, {
                            resendOtp: handleRequestOtp,
                            phoneNumber: "+62".concat(phoneNumber),
                            verificationMethod: (0,verification/* verificationTypeMapByValue */.DY)(verificationMethod),
                            verifyOtp: handleVerifyOtp,
                            errorVerifyOtp: errorVerifyOtp
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_LoginPage = (LoginPage);

;// CONCATENATED MODULE: ./src/pages/login.ts
var __N_SSP = true;



/***/ }),

/***/ 531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ SignUpAttr; }
/* harmony export */ });
var SignUpAttr;
(function(SignUpAttr) {
    SignUpAttr["SIGN_IN_FORM"] = "sign_in_form";
    SignUpAttr["SERVICE_SELECTION_BRIDGING_LOAN_APPLY"] = "service_selection_bridging_loan_apply";
    SignUpAttr["NAV_BAR_BRIDGING_LOAN_APPLY"] = "nav_bar_bridging_loan_apply";
    SignUpAttr["HERO_BANNER_BRIDGING_LOAN_APPLY"] = "hero_banner_bridging_loan_apply";
    SignUpAttr["BRIDGING_LOAN_PRODUCT_SELECTION"] = "bridging_loan_product_selection";
    SignUpAttr["BOTTOM_BANNER_BRIDGING_LOAN_APPLY"] = "bottom_banner_bridging_loan_apply";
    SignUpAttr["SIMULATION_BRIDGING_LOAN_APPLY"] = "simulation_bridging_loan_apply";
})(SignUpAttr || (SignUpAttr = {}));


/***/ }),

/***/ 8289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"login-page__navbar":"styles_login-page__navbar__VpYaB","login-page__title":"styles_login-page__title__h2dQT","login-page__form":"styles_login-page__form__cdmuq","login-page__chip":"styles_login-page__chip__5Ba59","link":"styles_link__WINts","login-form__section_center":"styles_login-form__section_center__WTAiZ","login-form__partners":"styles_login-form__partners__oI5Rb","login-form__partner-logo":"styles_login-form__partner-logo__f7gwt"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [377,348,995,774,888,179], function() { return __webpack_exec__(7705); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);